import { render } from "./AgencyCampaigns.vue?vue&type=template&id=28a3264d&scoped=true"
import script from "./AgencyCampaigns.vue?vue&type=script&lang=js"
export * from "./AgencyCampaigns.vue?vue&type=script&lang=js"

import "./AgencyCampaigns.vue?vue&type=style&index=0&id=28a3264d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a3264d"]])

export default __exports__